import { polyCountForValue } from 'Pods/ThreeDStudio/Services/polyCountForValue'

/**
 * Builds the modelSettings patch that pulls a target polycount back into a range
 * it no longer fits - the smart low poly toggle switches the provider to its
 * dedicated low-poly model (meshy T2, tripo3d P1), whose range is much narrower
 * than the standard model's. Empty patch when the target is still valid.
 *
 * @param {number|string|undefined} targetPolycount - Current target polycount.
 * @param {Object} [range] - { minimum, maximum, default } of the new range.
 * @returns {Object} A patch with targetPolycount/polyCount, or an empty object.
 */
export function clampTargetPolycountPatch(targetPolycount, range) {
  const { minimum, maximum, default: defaultValue } = range || {}
  const value = Number(targetPolycount)
  const isOutOfRange = targetPolycount != null && targetPolycount !== ''
    && minimum != null && maximum != null
    && (value < minimum || value > maximum)

  if (!isOutOfRange) {
    return {}
  }

  return { targetPolycount: defaultValue, polyCount: polyCountForValue(defaultValue, range) }
}
